import {
  LOCAL_ACTIVE_ROL_NAME,
  LOCAL_COMPANY_ID,
  LOCAL_COMPANY_NAME,
  LOCAL_NAME_COMPANY,
  LOCAL_USER_ID,
  ORGANIZATION_DEMO,
} from "../../utils/storage"
  ; (function (p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
      p.GlobalSnowplowNamespace.push(i); p[i] = function () {
        (p[i].q = p[i].q || []).push(arguments)
      }; p[i].q = p[i].q || []; n = l.createElement(o); g = l.getElementsByTagName(o)[0]; n.async = 1;
      n.src = w; g.parentNode.insertBefore(n, g)
    }
  }(window, document, "script", "//storage.googleapis.com/snowplow-cto-office-tracker-bucket/3.1.1/sp.js", "snowplow"));
var context_customer = {
  customer_name: LOCAL_COMPANY_NAME(), // Secondary company name. Set equal to customer_name or leave blank if inapplicable
  organization_no: LOCAL_COMPANY_ID(),
  business_unit: "ManduPE",
}
var context_product = {
  r12: "031",
  product_name: "Engagement",
}
var context_user = {
  user_type: LOCAL_ACTIVE_ROL_NAME(),
}

var contexts = [
  {
    schema: "iglu:com.visma-tech-hubs/context_customer/jsonschema/1-0-0",
    data: context_customer,
  },
  {
    schema: "iglu:com.visma-tech-hubs/context_product/jsonschema/1-0-0",
    data: context_product,
  },
  {
    schema: "iglu:com.visma-tech-hubs/context_user/jsonschema/1-0-0",
    data: context_user,
  },
]
// EVENT METHODS END ---------------
export const testSnowplow = () => {
  /*   let snowplowLoad = (p, l, o, w, i, n, g) => {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
      p.GlobalSnowplowNamespace.push(i)
      p[i] = () => {
        ;(p[i].q = p[i].q || []).push(arguments)
      }
      p[i].q = p[i].q || []
      n = l.createElement(o)
      g = l.getElementsByTagName(o)[0]
      n.async = 1
      n.src = w
      g.parentNode.insertBefore(n, g)
    }
  }
  snowplowLoad(window,
    document,
    "script",
    "//storage.googleapis.com/snowplow-cto-office-tracker-bucket/3.1.1/sp.js",
    "snowplow"
  ) */
  if (ORGANIZATION_DEMO() == 0) {

    window.snowplow("newTracker", "cf", process.env.URL_SNOWPLOW, {
      // Initialise a tracker
      appId: "mandu",
      platform: "web", // possible values (default is web): web, mob, app, pc, srv
      forceSecureTracker: true, // Force collector to use https protocol regardless of protocol of current page
      // anonymousTracking: true, // Use this option in case you want to anonymise your tracking. This will set user_ids and domain ids to 'null'
      contexts: {
        webPage: true, // Common id for webpages
        performanceTiming: true, // Creates performance contexts to create performance metrics of pages
        // geolocation: true    // Prompts user for geolocation data
      },
    })
    window.snowplow('addGlobalContexts', [contexts]);
    window.snowplow("setUserId", LOCAL_USER_ID())
    var config = {
      forms: {
        blacklist: [],
      },
      fields: {
        blacklist: ["sensitive-field"],
      },
    }

    window.snowplow("enableLinkClickTracking", {
      context: contexts,
      pseudoClicks: true,
      trackContent: true,
    })
    window.snowplow("enableFormTracking", config, contexts)

    window.snowplow("enableFormTracking", {}, contexts) // Enable all form submits

    window.snowplow("enableActivityTracking", {
      minimumVisitLength: 30,
      heartbeatDelay: 20,
    })
    // Initialize page view events. Timer is reset for each time the page is loaded
    window.snowplow('trackPageView', {
      title: document.title,
      context: contexts
    });

  }
}
export const buttonAction_s = (data_button) => {

  if (ORGANIZATION_DEMO() == 0) {
    window.snowplow("trackStructEvent", {
      category: data_button.category,
      action: data_button.action,
      label: data_button.label,
      property: data_button.property,
      value: null,
      context: contexts,
    })
    if (contexts.length > 3) contexts.pop()
  }
}
export const buttonAction_btns = (tipo) => {

  if (ORGANIZATION_DEMO() == 0) {
    let data_button_prev = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: tipo,
      label: `Click a ${tipo}`,
      property: "button",
      value: LOCAL_USER_ID(),
    }
    buttonAction_s(data_button_prev)
  }
}
export const buttonAction_context = (tipo, name, custom1) => {
  if (ORGANIZATION_DEMO() == 0) {
    let data_button_prev = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: tipo,
      label: `Click a ${tipo}`,
      property: "button",
      value: LOCAL_USER_ID(),
    }
    var context_custom = {
      custom_name: name,
      customfield_custom1: custom1,
    }
    contexts.push({
      schema: "iglu:com.visma-tech-hubs/context_custom/jsonschema/1-0-0",
      data: context_custom,
    })
    buttonAction_s(data_button_prev)
  }
}
export const PageView = (pagina, name, custom1) => {

  if (ORGANIZATION_DEMO() == 0) {
    if (name != null) {
      var context_custom = {
        custom_name: name,
        customfield_custom1: custom1,
      }
      contexts.push({
        schema: "iglu:com.visma-tech-hubs/context_custom/jsonschema/1-0-0",
        data: context_custom,
      })
    }

    window.snowplow('trackPageView', {
      title: pagina,
      context: contexts
    });
  }
}
